"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLikerIdByWallet = exports.getLikeWalletByLikerId = void 0;
const axios_1 = __importDefault(require("axios"));
async function getLikeWalletByLikerId(likerId, _temp) {
  let {
    LIKE_CO_API_ROOT = 'https://api.like.co'
  } = _temp === void 0 ? {} : _temp;
  var _a, _b, _c;
  try {
    const userDataResponse = await axios_1.default.get(`${LIKE_CO_API_ROOT}/users/id/${likerId}/min`);
    return (_a = userDataResponse === null || userDataResponse === void 0 ? void 0 : userDataResponse.data) === null || _a === void 0 ? void 0 : _a.likeWallet;
  } catch (error) {
    if (((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status) !== 404) {
      // eslint-disable-next-line
      console.error('getLikeWalletByLikerId Error', ((_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) || error);
      throw error;
    }
    return null;
  }
}
exports.getLikeWalletByLikerId = getLikeWalletByLikerId;
async function getLikerIdByWallet(wallet, _temp2) {
  let {
    LIKE_CO_API_ROOT = 'https://api.like.co'
  } = _temp2 === void 0 ? {} : _temp2;
  var _a, _b, _c;
  try {
    const addrDataResponse = await axios_1.default.get(`${LIKE_CO_API_ROOT}/users/addr/${wallet}/min`);
    return (_a = addrDataResponse === null || addrDataResponse === void 0 ? void 0 : addrDataResponse.data) === null || _a === void 0 ? void 0 : _a.user;
  } catch (error) {
    if (((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status) !== 404) {
      // eslint-disable-next-line
      console.error('getLikerIdByWallet Error', ((_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) || error);
      throw error;
    }
    return null;
  }
}
exports.getLikerIdByWallet = getLikerIdByWallet;